import { DEFAULT_LOCALE, LOCALES } from '../constants';

/**
 * @param locale - The locale to validate
 * @param allowedLocales - The list of allowed locales
 * @returns A valid locale
 * @description This function checks if the provided locale is in the list of allowed locales.
 * If it is, it returns the provided locale. If not, it returns the default locale.
 *
 * If no allowed locales are provided, it will allow `en`, `de-DE`, `pt-BR`, `es-ES`.
 */
export const getValidLocale = <T>({
  locale,
  allowedLocales,
}: {
  locale: string | undefined;
  allowedLocales?: T[] | undefined;
}): T => {
  const validLocales = (allowedLocales ?? LOCALES) as T[];

  return validLocales.includes(locale as T)
    ? (locale as T)
    : (DEFAULT_LOCALE as T);
};
